import * as React from "react";
import {
  Button,
  Checkbox,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  TextField,
  Theme,
  withStyles,
} from "@material-ui/core";

import { API } from "aws-amplify";
import { TransitionProps } from "@material-ui/core/transitions";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import UpdateIdentityValidationStatusResult from "./UpdateIdentityValidationStatusResult";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

interface IUpdateIdentityValidationStatusState {
  alertMessagePersonId: string;
  formSubmitted: boolean;
  identityValidationStatusDemographic: string;
  identityValidationStatusKatara: boolean;
  message: string;
  open: boolean;
  personId: string;
  response: any;
  resultSuccessful: boolean;
}

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class UpdateIdentityValidationStatusSection extends React.Component<
  any,
  IUpdateIdentityValidationStatusState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      alertMessagePersonId: "",
      formSubmitted: false,
      identityValidationStatusDemographic: "VALIDATION_SUCCESS",
      identityValidationStatusKatara: true,
      message: "",
      open: false,
      personId: "",
      response: "",
      resultSuccessful: false,
    };

    this.handlePersonId = this.handlePersonId.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleIdentityValidationStatusKatara =
      this.handleIdentityValidationStatusKatara.bind(this);
    this.handleIdentityValidationStatusDemographic =
      this.handleIdentityValidationStatusDemographic.bind(this);
  }

  public render() {
    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="Person Id (Required)"
              variant="outlined"
              value={this.state.personId}
              onChange={this.handlePersonId}
            />
          </Grid>

          <Grid item xs>
            <FormControl>
              <InputLabel>
                Identity Validation Status Demographic (Required)
              </InputLabel>
              <Select
                value={this.state.identityValidationStatusDemographic}
                onChange={this.handleIdentityValidationStatusDemographic}
                style={{ width: 225 }}
              >
                <MenuItem value="VALIDATION_SUCCESS">Success</MenuItem>
                <MenuItem value="VALIDATION_FAILED">Failed</MenuItem>
                <MenuItem value="VALIDATION_NOT_AVAILABLE">
                  Not Available
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs>
            <FormControl component="fieldset">
              <FormGroup style={{ width: 225 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.identityValidationStatusKatara}
                    />
                  }
                  label="Override Identity Validation Status In Katara"
                  onChange={this.handleIdentityValidationStatusKatara}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item xs>
            <Button
              variant="outlined"
              color="default"
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </Grid>

          <Grid item xs={12}>
            {this.state.formSubmitted && <LoadingSpinner />}
            {this.state.resultSuccessful && (
              <UpdateIdentityValidationStatusResult
                response={this.state.response}
                heading={"Update Identity Validation Status Response"}
                personId={this.state.alertMessagePersonId}
              />
            )}
          </Grid>

          {this.state.message && (
            <Dialog
              open={this.state.open}
              TransitionComponent={TransitionConst}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              onClose={this.handleClose}
            >
              <DialogTitle id="alert-dialog-slide-title">
                {"Identity Validation Status Response"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {this.state.message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Grid>
      </Grid>
    );
  }

  public handleClose() {
    this.setState({ open: false });
  }

  public handlePersonId(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ personId: event.target.value });
    this.setState({ alertMessagePersonId: event.target.value });
  }

  public handleIdentityValidationStatusKatara(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    this.setState({ identityValidationStatusKatara: event.target.checked });
  }

  private handleIdentityValidationStatusDemographic(
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) {
    this.setState({ identityValidationStatusDemographic: event.target.value });
  }

  private handleValidation() {
    let formIsValid = true;
    if (!this.state.personId) {
      alert("Please enter the person id");
      formIsValid = false;
    } else if (
      !this.state.personId.match(
        "^amzn[1-9]+[0-9]*.([A-Za-z0-9]+.)+A[A-Z0-9]*$"
      )
    ) {
      alert("Please enter the valid personId.");
      formIsValid = false;
    }
    return formIsValid;
  }

  private handleSubmit() {
    if (this.handleValidation()) {
      this.setState({ formSubmitted: true });
      this.setState({ resultSuccessful: false });

      const apiName = "ApaqPortalAPI";
      const path = "/pharmacy-customer/update/identity-validation";
      const config = {
        body: {
          identityValidationForKatara:
            this.state.identityValidationStatusKatara,
          identityValidationStatus:
            this.state.identityValidationStatusDemographic,
          personId: this.state.personId,
        },
        headers: {},
      };

      API.post(apiName, path, config)
        .then((response) => {
          console.log(response);
          this.setState({ resultSuccessful: true });
          this.setState({ formSubmitted: false });
          this.setState({ personId: "" });
          this.setState({ response });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ open: true });
          this.setState({ formSubmitted: false });
          this.setState({ message: error.response.data.message });
        });
    }
  }
}

export default withStyles(styles)(UpdateIdentityValidationStatusSection);
